import { SET_USER_ACTIONS_CHECKLIST } from "./types";
import { UserActionsCheckList } from "refsix-js-models";

export const setUserActionsCheckList = (
    userActionsCheckList: UserActionsCheckList
) => ({
    type: SET_USER_ACTIONS_CHECKLIST,
    userActionsCheckList,
});
